import OAuth2 from 'react-simple-oauth2-login';
import axios from 'axios';
import { useInitAlerts, useAddAlert, useUser, useUserTokens } from '../../store/actions';
import React, { useEffect} from 'react';
import { alertMessages } from '../../constants';
import { useStoreContext } from '../../store/context';
import Button from '@mui/material/Button';
import './Login.css';
import { useLocation, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { errorResponse } from 'src/store/common';
import moment from 'moment';

export const transformData = (params:any) =>{
  let appRoles:any;
  if(params.applicationRoles && params.applicationRoles.length>0){
    appRoles = params.applicationRoles.map((role:any)=> role.applicationRoleKey);
  }
  else{
    appRoles=null;
  }
  return({
    firstName: params.firstName,
    lastName: params.lastName,
    email: params.eMail,
    napIdentifier: params.napIdentifier,
    appRoles: appRoles
  })
};

export const getTokens = (authCode: any, accessToken: any, refreshToken: any, expiresIn: any)=>{
  return({
    authCode: authCode,
    accessToken: accessToken,
    refreshToken: refreshToken,
    expiresIn: expiresIn
  })
}
export const setAccessTokenCookie = (token:string, cookieName:string,expireTime: number)=>{
  Cookies.set(cookieName, token, {
    expires: expireTime,
    //domain: 'http://localhost:3000/',
     secure: true, 
    // sameSite: 'Strict',
    // httpOnly: true,
  })
};

export const getAccessTokenCookie = (cookieName:string)=>{
  return Cookies.get(cookieName);
};

export const removeAccessTokenCookie =(cookieName:string)=>{
  Cookies.remove(cookieName);
};
export const AuthProvider = () => {
  const [, dispatch] = useStoreContext();
  const setUser = useUser(dispatch);
  const setUserTokens = useUserTokens(dispatch);

  const initAlerts = useInitAlerts(dispatch);
  const addAlert = useAddAlert(dispatch);
  const inputRef = React.useRef<HTMLButtonElement>(null);
  const location = useLocation();
  const history = useHistory();

  useEffect(()=>{
    if(inputRef.current!==null && ((location.pathname.includes('xyzadmin'))
    || (location.pathname.includes('/inap') ))){
      inputRef.current.click();
      const timer = setTimeout(()=> {
        history.push({pathname:`/ui`, key: 'from-inap'})
      }, 1000);
      return () => clearTimeout(timer);
    }
  },[location.pathname,history])

  const onSuccess = (response:any) =>{
    initAlerts();
    let authCode = response?.code;
    axios.get(`${process.env.REACT_APP_REQUEST_URL}${authCode}`)
    .then(function (response) {
      // handle success
      const { jwt } = response.data;
      if (jwt.authorized === "false") {
        window.open(jwt.napRedirectURL, '_blank');
        addAlert({
          id:'',
          message: alertMessages.inapProcess,
          type:'informative',
          icon:'fa-info-circle'
        })
      } else {
        const userInfo =transformData(JSON.parse(response.data.jwt?.napUserProfile));
        localStorage.setItem('user', JSON.stringify({exp: new Date(), userInfo}));
        localStorage.setItem('authExpires',moment().utc().add(Number(response.data.codeResponse.expires_in), 'seconds').format())
        setUser(userInfo);
        setUserTokens(getTokens(authCode, response.data.codeResponse.access_token, response.data.codeResponse.refresh_token, response.data.codeResponse.expires_in));
        const expTime = (response.data.codeResponse.expires_in+200)/86400;
        setAccessTokenCookie(response.data.codeResponse.access_token, 'accessToken', expTime);
        setAccessTokenCookie(response.data.codeResponse.refresh_token, 'refreshToken', expTime);
        setAccessTokenCookie(authCode, 'authCode',expTime);
        setAccessTokenCookie(response.data.codeResponse.expires_in, 'expiresIn',expTime);
        globalThis.location.reload()
      }
    }) 
    .catch(function (error) {
      console.log('error', error);
      errorResponse(response, addAlert, alertMessages.loginError);
    })
  }

  const onFailure = (response:any) => {
    console.log('error:', response);
    errorResponse(response, addAlert, alertMessages.loginError);
    
  };

  const Login = (props: any) =>{
      return(
        <div className="login-2">
          <Button {...props} variant="contained" ref={inputRef} style={{textTransform:'capitalize'}}>Login</Button>
        </div>
      )
  }

  return (
    <>
    {
      <OAuth2
        authorizationUrl={`${process.env.REACT_APP_FAMAUTH_URL}`}
        responseType="code"
        clientId= {`${process.env.REACT_APP_CLIENT_ID}`}
        redirectUri={`${process.env.REACT_APP_REDIRECT_URI}`}
        onSuccess={onSuccess}
        onFailure={onFailure}
        extraParams = {
          { state:"xyzadmin"}
        }
        render={Login}
      />
    }
    </>
  );
};
